import { AuthenticationError } from "apollo-server-errors";
import UserToken from "@/lib/userToken";
import { AUTH_ERROR_MESSAGES } from "@/lib/errors";
import { metaSchemas, userRating } from "@/lib/constants";
import { isEnded } from "@/lib/metaUtil";
import dayjs from "@/lib/day";
import config from "@/lib/config";
export async function createToken(req, res, user, signature) {
  var _user$user;
  const userToken = new UserToken(req, res);
  const payload = {
    id: user.token_id,
    hashedUserId: user === null || user === void 0 || (_user$user = user.user) === null || _user$user === void 0 || (_user$user = _user$user.values) === null || _user$user === void 0 ? void 0 : _user$user.user_id_hash,
    accessToken: user.access_token,
    refreshToken: user.refresh_token,
    tokenExpiredAt: dayjs().add(user.expires_in, "second").format()
  };
  const token = await userToken.sign(payload, signature);
  req.userToken = payload;
  return token;
}
export function sleep(n) {
  return new Promise(resolve => setTimeout(resolve, n));
}
export function createPageInfo(_ref) {
  let {
    offset,
    limit,
    count
  } = _ref;
  return {
    offset,
    limit,
    totalCount: count,
    hasNextPage: offset + limit < count,
    hasPreviousPage: offset > 0
  };
}
export function thumbnailUrl(obj, _args, _ref2) {
  var _obj$thumbnail;
  let {
    req
  } = _ref2;
  if (!isAllowedRating(req, obj)) {
    return "/images/mask.png";
  }
  const noimage = "/images/noimage.png";
  return (obj === null || obj === void 0 || (_obj$thumbnail = obj.thumbnail) === null || _obj$thumbnail === void 0 ? void 0 : _obj$thumbnail.org) || noimage;
}
export function smallThumbnailUrl(obj, _args, _ref3) {
  var _obj$thumbnail2;
  let {
    req
  } = _ref3;
  if (!isAllowedRating(req, obj)) {
    return "/images/mask.png";
  }
  const noimage = "/images/noimage.png";
  return (obj === null || obj === void 0 || (_obj$thumbnail2 = obj.thumbnail) === null || _obj$thumbnail2 === void 0 ? void 0 : _obj$thumbnail2.small) || noimage;
}
export function mediumThumbnailUrl(obj, _args, _ref4) {
  var _obj$thumbnail3;
  let {
    req
  } = _ref4;
  if (!isAllowedRating(req, obj)) {
    return "/images/mask.png";
  }
  const noimage = "/images/noimage.png";
  return (obj === null || obj === void 0 || (_obj$thumbnail3 = obj.thumbnail) === null || _obj$thumbnail3 === void 0 ? void 0 : _obj$thumbnail3.medium) || noimage;
}
export function largeThumbnailUrl(obj, _args, _ref5) {
  var _obj$thumbnail4;
  let {
    req
  } = _ref5;
  if (!isAllowedRating(req, obj)) {
    return "/images/mask.png";
  }
  const noimage = "/images/noimage.png";
  return (obj === null || obj === void 0 || (_obj$thumbnail4 = obj.thumbnail) === null || _obj$thumbnail4 === void 0 ? void 0 : _obj$thumbnail4.large) || noimage;
}
export function isAuthenticated() {
  return next => async (root, args, context, info) => {
    if (!context.req.userToken) {
      throw new AuthenticationError(AUTH_ERROR_MESSAGES["notauthenticated"]);
    }
    return next(root, args, context, info);
  };
}
export function values(obj, name) {
  var _obj$values;
  return obj === null || obj === void 0 || (_obj$values = obj.values) === null || _obj$values === void 0 ? void 0 : _obj$values[name];
}
export function ownerOnly() {
  return next => async (root, args, context, info) => {
    var _context$req;
    const userToken = (_context$req = context.req) === null || _context$req === void 0 ? void 0 : _context$req.userToken;
    if (!userToken) {
      throw new AuthenticationError(AUTH_ERROR_MESSAGES["notauthenticated"]);
    }
    if (userToken.id !== userToken.currentProfile) {
      throw new AuthenticationError(AUTH_ERROR_MESSAGES["notauthenticated"]);
    }
    return next(root, args, context, info);
  };
}
export function metaResolveType(meta, _context, _info) {
  var _meta$values, _meta$values4;
  if (meta.schema_key) {
    switch (meta.schema_key) {
      case metaSchemas.tvshow.key:
        return "TVShowMeta";
      case metaSchemas.season.key:
        return "SeasonMeta";
      case metaSchemas.episode.key:
        if (meta !== null && meta !== void 0 && (_meta$values = meta.values) !== null && _meta$values !== void 0 && _meta$values.is_live) {
          var _meta$values2, _meta$values3;
          const ended = isEnded(meta === null || meta === void 0 || (_meta$values2 = meta.values) === null || _meta$values2 === void 0 ? void 0 : _meta$values2.encode_end_date);
          // ライブが終わって見逃し対応ならEpisodeMetaとして扱う
          if (meta !== null && meta !== void 0 && (_meta$values3 = meta.values) !== null && _meta$values3 !== void 0 && _meta$values3.catch_up_flag && ended) {
            return "EpisodeMeta";
          } else {
            return "LiveMeta";
          }
        } else {
          return "EpisodeMeta";
        }
      case metaSchemas.channel.key:
        return "ChannelMeta";
      case metaSchemas.linear.key:
        return "LinearMeta";
    }
  } else if (meta.schema_id) {
    switch (meta.schema_id) {
      case metaSchemas.tvshow.id:
        return "TVShowMeta";
      case metaSchemas.season.id:
        return "SeasonMeta";
      case metaSchemas.episode.id:
        if (meta !== null && meta !== void 0 && (_meta$values4 = meta.values) !== null && _meta$values4 !== void 0 && _meta$values4.is_live) {
          var _meta$values5, _meta$values6;
          const ended = isEnded(meta === null || meta === void 0 || (_meta$values5 = meta.values) === null || _meta$values5 === void 0 ? void 0 : _meta$values5.encode_end_date);
          // ライブが終わって見逃し対応ならEpisodeMetaとして扱う
          if (meta !== null && meta !== void 0 && (_meta$values6 = meta.values) !== null && _meta$values6 !== void 0 && _meta$values6.catch_up_flag && ended) {
            return "EpisodeMeta";
          } else {
            return "LiveMeta";
          }
        } else {
          return "EpisodeMeta";
        }
      case metaSchemas.channel.id:
        return "ChannelMeta";
      case metaSchemas.linear.id:
        return "LinearMeta";
    }
  }
  return null;
}
export function taxCalculation(price) {
  if (typeof price !== "number") return null;
  return Math.floor(price + price * config.taxRate);
}
export function genres(obj) {
  const genres = values(obj, "genres");
  // 複数ジャンルが入稿されたメタの場合
  // 親ジャンル1, 子ジャンル1, 親ジャンル2, 子ジャンル2
  // と入っているので先頭2件までにする
  if (genres.length > 2) {
    return genres.slice(0, 2);
  } else {
    return genres;
  }
}
export function isDateRangeIn(start, end) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    buffer: null,
    default: true
  };
  const now = function () {
    if (options.buffer) {
      // {buffer: [1, "minute"]}
      return dayjs().add(...options.buffer);
    } else {
      return dayjs();
    }
  }();
  const startAt = dayjs(new Date(start));
  const endAt = dayjs(new Date(end));
  if (start && end) {
    return now.isBetween(startAt, endAt, null, "[)");
  } else if (start && !end) {
    return now.isSameOrAfter(startAt);
  } else if (!start && end) {
    return now.isBefore(end);
  } else {
    return options === null || options === void 0 ? void 0 : options.default;
  }
}
export function logicaErrorCode(e) {
  var _e$extensions;
  if (e !== null && e !== void 0 && (_e$extensions = e.extensions) !== null && _e$extensions !== void 0 && _e$extensions.response) {
    var _e$extensions$respons, _body$error;
    console.dir(e.extensions.response);
    const body = (_e$extensions$respons = e.extensions.response) === null || _e$extensions$respons === void 0 ? void 0 : _e$extensions$respons.body;
    return (_body$error = body.error) === null || _body$error === void 0 ? void 0 : _body$error.code;
  } else {
    return 500;
  }
}
export function logicaErrorBody(e) {
  var _e$extensions2;
  if (e !== null && e !== void 0 && (_e$extensions2 = e.extensions) !== null && _e$extensions2 !== void 0 && _e$extensions2.response) {
    var _e$extensions$respons2;
    console.dir(e.extensions.response);
    const body = (_e$extensions$respons2 = e.extensions.response) === null || _e$extensions$respons2 === void 0 ? void 0 : _e$extensions$respons2.body;
    return body;
  } else {
    return {};
  }
}
export function isAllowedRating(req, meta) {
  var _req$userToken;
  if (req.userToken && typeof ((_req$userToken = req.userToken) === null || _req$userToken === void 0 ? void 0 : _req$userToken.rating) !== "undefined") {
    const rating = req.userToken.rating;
    const permitRating = userRating[rating].permitRating;
    return permitRating.includes(meta.values.rating);
  }
  return true;
}
export function ratingMask(req, meta, attr) {
  if (!isAllowedRating(req, meta)) {
    return meta[attr].replace(/./g, "*");
  }
  return meta === null || meta === void 0 ? void 0 : meta[attr];
}
export function dateFormat(date) {
  let format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "YYYY/MM/DD";
  if (!date) return null;
  return dayjs(date).format(format);
}